var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d8b4fe;\n      }\n\n      .st1, .st2 {\n        fill: #6b21a8;\n      }\n\n      .st3, .st4 {\n        fill: #a78bfa;\n      }\n\n      .st5, .st2, .st4, .st6 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        font-family: Arial-BoldMT, Arial;\n        font-size: 180px;\n        font-weight: 700;\n      }\n\n      .st4 {\n        opacity: .5;\n      }\n\n      .st7 {\n        fill: none;\n        stroke: #d8b4fe;\n        stroke-linecap: round;\n        stroke-width: 40px;\n      }\n\n      .st8 {\n        stroke: #6b21a8;\n        stroke-width: 50px;\n      }\n\n      .st8, .st6 {\n        fill: #fff;\n      }\n\n      .st6 {\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 60,
    y: 21,
    width: 720,
    height: 960,
    rx: 70,
    ry: 70
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(228.92 301)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "POD"))))), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 180,
    y1: 411,
    x2: 695,
    y2: 411
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 180,
    y1: 561,
    x2: 580,
    y2: 561
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 180,
    y1: 711,
    x2: 500,
    y2: 711
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 459.49,
    y: 613.68,
    width: 500,
    height: 120,
    rx: 15,
    ry: 15,
    transform: "translate(-268.56 699) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 459.49,
    y: 653.68,
    width: 500,
    height: 40,
    transform: "translate(-268.56 699) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.29,808.03l-7.07,35.36,14.14,42.43,42.43,14.14,35.36-7.07-84.85-84.85h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.22,843.39v56.57h56.57l-56.57-56.57h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 874.81,
    y: 433.37,
    width: 30,
    height: 120,
    transform: "translate(-88.25 773.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 890.06,
    y: 434.13,
    width: 8,
    height: 110,
    transform: "translate(-84 775.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 891.63,
    y: 401.55,
    width: 60,
    height: 120,
    rx: 10,
    ry: 10,
    transform: "translate(-56.43 786.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 901.63,
    y: 441.55,
    width: 40,
    height: 40,
    rx: 5,
    ry: 5,
    transform: "translate(-56.43 786.87) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodDocument);
export default __webpack_public_path__ + "static/media/podDocument.512065c7836f131ad630509d4046c7f6.svg";
export { ForwardRef as ReactComponent };